// StartPage.jsx
import { http } from "../../lib/http";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

function StartPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function initSession() {
      try {
        const data = await http.get(
          `/web/resolve-session/${token}`,{
            withCredentials: true,
          }
        );
  
        console.log("session token token file", data);
  
        navigate(`/partners/${data.restaurant_id}/products`);
      } catch (err) {
        console.error(err);
        alert("Invalid or expired link");
      }
    }
  
    initSession();
  }, [token,navigate]);

  return <div>Starting session...</div>;
}

export default StartPage;
